<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <DateBar
          :dateRange="dateRange"
          @updateRange="
            (value, startDate, index) => {
              dateRange = index;
              $emit('get-subscriptions', startDate);
            }
          "
          format-date="YYYY-MM-DD"
        />
        <DateFilters
          :initialDate="startDate"
          :finalDate="endDate"
          @updateInitialDate="$emit('update-dates', 'startDate', $event)"
          @updateFinalDate="$emit('update-dates', 'endDate', $event)"
        />
      </v-col>
    </v-row>
    <slot name="cards" />
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="12" sm="1" md="2">
                <v-text-field
                  ref="button-search"
                  v-model="table.search"
                  @input="$emit('get-subscriptions')"
                  @click:append="
                    table.search ? $emit('get-subscriptions') : null
                  "
                  :label="$t('actions.search')"
                  solo
                  flat
                  dense
                  background-color="grey lighten-2"
                  append-icon="search"
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
                md="2"
                class="d-flex justify-end align-center"
              >
                <v-select
                  :items="statuses"
                  v-model="table.state"
                  @change="$emit('get-subscriptions')"
                  :label="$t('actions.filter_by_status')"
                  item-text="name"
                  item-value="name"
                  solo
                  flat
                  dense
                  background-color="grey lighten-2"
                  hide-details
                  clearable
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
                md="2"
                class="d-flex justify-end align-center"
              >
                <v-select
                  :items="allGateways"
                  v-model="table.gateway"
                  @change="$emit('get-subscriptions')"
                  :label="$t('actions.filter_by_gateway')"
                  item-text="name"
                  item-value="value"
                  solo
                  flat
                  dense
                  background-color="grey lighten-2"
                  hide-details
                  clearable
                />
              </v-col>

              <!-- EXPORT BUTTON DISABLED -->

              <!-- <v-col
                  cols="12"
                  sm="2"
                  md="6"
                  class="d-flex justify-end align-center"
                >
                  v-if="permissions.includes('dashboard-export') && table.total"
                  @click.native="$emit('active-export-dialog')"
                  <v-btn
                    ref="open-dialog-export"
                    small
                    color="primary"
                    class="mr-2"
                  >
                    <v-icon left>
                      cloud_download
                    </v-icon>
                    {{ $t("subscriptions.dashboard.export") }}
                  </v-btn>
                </v-col> -->
            </v-row>
          </v-card-title>

          <v-data-table
            ref="table-subscriptions"
            :headers="headers"
            :items="table.items"
            :options="table.pagination"
            :footer-props="{ 'items-per-page-options': [5, 10, 25, 50, 100] }"
            :items-per-page="table.pagination.itemsPerPage"
            :server-items-length="table.total"
            :loading="loading"
            :no-data-text="$t('subscriptions.dashboard.empty')"
            :no-results-text="$t('subscriptions.dashboard.empty_search')"
            @update:options="$emit('table-pagination', $event)"
          >
            <!-- SHOWS NO DATA -->
            <template v-slot:no-data>
              <div class="text-center pa-5 my-5">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t("subscriptions.dashboard.empty") }}
                </div>
              </div>
            </template>

            <template v-if="table.items.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          <span>
                            {{ item.id }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          <span>
                            {{ item.organization.name }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td
                    :style="{
                      color: getStateForColor(item.state),
                      'font-weight': getStateForFontWeight(item.state)
                    }"
                    :class="[getStateForTextColor(item.state)]"
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    {{ getStateByNumber(item.state) }}
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span>
                      {{ $moment(item.created_at).format("DD/MM/YYYY") }}
                    </span>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span> $ {{ item.conversion_amount }} USD </span>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span>
                      {{ item.gateway.gateway.name }}
                    </span>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span>
                      {{ $moment(item.next_payment_date).format("DD/MM/YYYY") }}
                    </span>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span>
                      {{ item.collected }}
                    </span>
                  </td>
                  <td
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    <span>
                      {{ item.remaining }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DateFilters from "@/components/Common/DateFilters/Index";
import DateBar from "@/components/Common/DateBar/Index";
import donationMixin from "@/mixins/donations";
export default {
  components: {
    DateFilters,
    DateBar
  },
  mixins: [donationMixin],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    table: {
      type: Object,
      required: true,
      default: () => {}
    },
    startDate: {
      type: String,
      required: true,
      default: new Date()
    },
    endDate: {
      type: String,
      required: true,
      default: new Date()
    },
    headers: {
      type: Array,
      required: true,
      default: () => []
    },
    statuses: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      dateRange: 6
    };
  },
  computed: {
    ...mapState({
      allGateways: ({ gateways: { allGateways } }) => allGateways
    })
  },
  methods: {
    ...mapActions({ getAllGateways: "gateways/getAllGateways" })
  },
  mounted() {
    this.getAllGateways();
  }
};
</script>

<style lang="scss" scoped></style>
